import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const contactSupportApi = createApi({
    reducerPath: "contactSupport",
    baseQuery: createCustomFetchBaseQuery(),
    endpoints: (builder) => ({
        contactSupport: builder.mutation({
            query: (data) => ({
                url: `/contact-us`,
                method: "POST",
                body: data,
            }),
        }),
        getContactSupport: builder.query({
            query: ({ page, status, keyword, limit }) => {
                let url = `/admin/contact-us?page=${page + 1}`;
                if (status) {
                    url += `&status=${status}`;
                }
                if (keyword) {
                    url += `&keyword=${keyword}`;
                }
                if (limit) {
                    url += `&limit=${limit}`;
                }
                return {
                    url,
                    method: "GET",
                }
            }
        }),
    }),
});


export const {
    useContactSupportMutation,
    useGetContactSupportQuery,
} = contactSupportApi;